import React, { useState, useEffect } from "react";
import "./ToggleSelect.scss";

const ToggleSelect = ({
  options = [],            // [{ label: 'Residential', value: 'res' }, ...]
  value = null,            // controlled value
  defaultValue = null,     // uncontrolled default
  onChange = () => {},
  allowDeselect = true,    // allow none selected
  name = "",
  className = ""
}) => {
  const [selected, setSelected] = useState(defaultValue);

  // sync controlled value
  useEffect(() => {
    if (value !== undefined) {
      setSelected(value);
    }
  }, [value]);

  const handleClick = (val) => {
    let newValue = val;

    if (allowDeselect && selected === val) {
      newValue = null; // deselect
    }

    setSelected(newValue);
    onChange(newValue);
  };

  return (
    <div className={`toggle-group ${className}`}>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          className={`toggle-btn ${
            selected === opt.value ? "active" : ""
          }`}
          onClick={() => handleClick(opt.value)}
        >
          {opt.label}
        </button>
      ))}

      {/* optional hidden input for forms */}
      {name && (
        <input
          type="hidden"
          name={name}
          value={selected || ""}
        />
      )}
    </div>
  );
};

export default ToggleSelect;